import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CountUp from 'react-countup';

function Facts({data}:any) {
    return ( 
        <div className="container-fluid facts pt-lg-0">
            <div className="container py-5 pt-lg-0">
                <div className="row gx-0">
                    <div className="col-lg-4 wow zoomIn" data-wow-delay="0.1s">
                        <div className="bg-danger shadow d-flex align-items-center justify-content-center p-4" style={{height: "150px"}}>
                            <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{width: "60px", height: "60px"}}>
                                <FontAwesomeIcon icon="star" className="text-danger"/>
                            </div>
                            <div className="ps-4">
                                <h5 className="text-white mb-0">مورد اعتماد شما</h5>
                                <h1 className="text-white mb-0" data-toggle="counter-up"><CountUp end={data.user} duration={5} separator=""/></h1>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
                        <div className="bg-light shadow d-flex align-items-center justify-content-center p-4" style={{height: "150px"}}>
                            <div className="bg-danger d-flex align-items-center justify-content-center rounded mb-2" style={{width: "60px", height: "60px"}}>
                                <FontAwesomeIcon icon="check" className="text-white"/>
                            </div>
                            <div className="ps-4">
                                <h5 className="text-danger mb-0">آزمون انجام شده</h5>
                                <h1 className="text-danger mb-0" data-toggle="counter-up"><CountUp end={data.exam} duration={5} separator=""/></h1>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 wow zoomIn" data-wow-delay="0.6s">
                        <div className="bg-danger shadow d-flex align-items-center justify-content-center p-4" style={{height: "150px"}}>
                            <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{width: "60px", height: "60px"}}>
                                <FontAwesomeIcon icon="list-check" className="text-danger"/>
                            </div>
                            <div className="ps-4">
                                <h5 className="text-white mb-0">آنلاین در حال آزمون</h5>
                                <h1 className="text-white mb-0" data-toggle="counter-up"><CountUp end={data.pend_exam} duration={5} separator=""/></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Facts;